import React from 'react'

const TrailerPlayButton = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
        <g id="play_button" transform="translate(0 -0.01)">
            <path id="Pfad_122" data-name="Pfad 122" d="M13,0A13,13,0,1,0,26,13,13,13,0,0,0,13,0Zm0,24.44A11.44,11.44,0,1,1,24.44,13,11.44,11.44,0,0,1,13,24.44Z" transform="translate(0 0.01)"/>
            <path id="Pfad_123" data-name="Pfad 123" d="M26.416,17.809l-4.69-7.5-1.305.848,4.16,6.687-4.17,6.687,1.336.8Z" transform="translate(-9.797 -4.944)"/>
        </g>
    </svg>
)

export default TrailerPlayButton